import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { lottieAnimations } from '@backrs_ui/common-ui/src/assets/lottieAnimations';
import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { Box } from '@mui/material';
import Lottie from 'lottie-react';
var CIRCLE_SIZE = 145;
var bootstrapAnimations = [
    { data: lottieAnimations.water, artboardFraction: 0.4 },
    { data: lottieAnimations.circleInParts, artboardFraction: 0.4 },
    { data: lottieAnimations.circleLoading, artboardFraction: 0.775 },
];
export var BootstrapLoading = function () {
    var animation = useState(function () { return bootstrapAnimations[Math.floor(Math.random() * bootstrapAnimations.length)]; })[0];
    return (_jsx(Box, { sx: loadingContainerSx, children: _jsx(Lottie, { animationData: animation.data, loop: true, style: { width: CIRCLE_SIZE / animation.artboardFraction } }) }));
};
var loadingContainerSx = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100dvh',
    backgroundColor: COLOR_TOKENS['Beige/25'],
};
